<template>
  <Dialog
      v-model="dialogVisibleTips"
      :title="$t('tips')"
      :width="'400'"
      :dialogVisible="dialogVisibleTips"
      @update:dialogVisible="close"
  >
    <template #content>
      <div class="inners_warning">
        <div style="font-size: 14px;margin: 5px 0px 10px 0px">{{ $t('common.email.read.back') }}</div>
      </div>
    </template>
    <template #footer>
      <div class="setting_center">
        <el-button size="small" style="margin-right: 10px" @click="close">{{ $t('common.no') }}</el-button>
        <el-button size="small" type="primary" @click="handleDelete" :loading="isloading">{{ $t('common.yes') }}</el-button>
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import Dialog from "@/components/Dialog.vue";
import {defineProps, ref, watch, defineEmits, computed} from "vue";
import {useRouter} from "vue-router";
import {ElMessage} from "element-plus";
import {useStore} from "vuex";
import {throttle} from "@/utils/mylodash"
import {TIME_OUT} from "@/utils/statusParams";
import {batchDeleteMassTask} from "@/api/groupSend";
import {replyMailApis} from "@/api/mail";

const router = useRouter()
const emit = defineEmits()
const dialogVisibleTips = ref(false)
const store = useStore()

const {value, multipleSelection, getGroupMailList, isSelectAll, targetEmailDetail} = defineProps({
  value: {type: Boolean, default: false},
  multipleSelection: {type: Array, default: () => []},
  getGroupMailList: {type: Function},
  isSelectAll: {type: Boolean, default: false},
  targetEmailDetail: {type: Object, default: () => ({})}
})

watch(() => value, (val) => {
  dialogVisibleTips.value = val;
}, {immediate: true})


const close = () => {
  emit("close")
}
const isloading = ref(false)
const teamId = computed(() => store.state.email.teamID)
const handleDelete = throttle(async () => {
  console.log(targetEmailDetail, 'delete')
  const payload = {
    id: targetEmailDetail.id
  }
  isloading.value = true
  await replyMailApis(payload).then(res => {
    ElMessage.success(res.message)
    isloading.value = false
    close()
  }).catch(e => {
    isloading.value = false
  })
}, TIME_OUT)
</script>

<style lang="less" scoped>
.inners_warning {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start !important;
}

.setting_center {
  display: flex;
  justify-content: flex-end !important;
}
</style>
